'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fadl';
var iconName = 'box-check';
var width = 448;
var height = 512;
var aliases = [];
var unicode = 'f467';
var svgPathData = ['M32 160l0 256c0 17.7 14.3 32 32 32l320 0c17.7 0 32-14.3 32-32l0-256-384 0zm7.3-32l168.7 0 0-80-95.1 0c-10.3 0-20 5-26 13.4L39.3 128zm93.2 199.6c-6.1-6.4-6-16.5 .4-22.6s16.5-5.9 22.6 .4l41.2 42.6 94.4-129.8c5.2-7.1 15.2-8.7 22.3-3.5s8.7 15.2 3.5 22.3L211.3 382.2c-2.8 3.8-7.1 6.2-11.8 6.5s-9.3-1.4-12.6-4.8l-54.4-56.3zM240 48l0 80 168.7 0-47.6-66.6c-6-8.4-15.7-13.4-26-13.4L240 48z', 'M335.1 16c20.7 0 40.1 10 52.1 26.8l48.9 68.5c7.7 10.8 11.9 23.9 11.9 37.2L448 416c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 148.5c0-13.3 4.2-26.3 11.9-37.2L60.8 42.8C72.9 26 92.3 16 112.9 16l222.1 0zM32 416c0 17.7 14.3 32 32 32l320 0c17.7 0 32-14.3 32-32l0-256-384 0 0 256zM291.1 218.2c5.2-7.1 15.2-8.7 22.3-3.5s8.7 15.2 3.5 22.3L211.3 382.2c-2.8 3.8-7.1 6.2-11.8 6.5s-9.3-1.4-12.6-4.8l-54.4-56.3c-6.1-6.4-6-16.5 .4-22.6s16.5-5.9 22.6 .4l41.2 42.6 94.4-129.8zM112.9 48c-10.3 0-20 5-26 13.4l-47.6 66.6 168.7 0 0-80-95.1 0zM240 128l168.7 0-47.6-66.6c-6-8.4-15.7-13.4-26-13.4l-95.1 0 0 80z'];

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faBoxCheck = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;